
import React from "react";
import { useIntl } from "react-intl";
import { EntityFormHeaderTitle } from "../../../common/entity-form";


type CreateRoleForRequestFormTitleProps = {
    onBackClick: () => void
}

const CreateRoleForRequestFormTitle:React.FC<CreateRoleForRequestFormTitleProps> = ({
    onBackClick
}) => {
    const intl = useIntl();

    return (
        <EntityFormHeaderTitle
            title={intl.formatMessage({ id: "create-new-role-for-request-page-header.title" })}
            onBackClick={onBackClick}
        />
    );
};

export default CreateRoleForRequestFormTitle;
